(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/caretech/caretech-checks/assets/javascripts/caretech-checks.js') >= 0) return;  svs.modules.push('/components/caretech/caretech-checks/assets/javascripts/caretech-checks.js');
'use strict';

svs.caretech = svs.caretech || {};
svs.caretech.caretech_checks = svs.caretech.caretech_checks || {};
const logger = svs.core.log.getLogger('components:caretech-checks');
const careTechMessageIdEnum = {
  LONGSESSION: 'LongSession'
};
function isCareTechMessage(messageId) {
  return Object.prototype.hasOwnProperty.call(careTechMessageIdEnum, messageId.toUpperCase());
}

svs.caretech.caretech_checks.show = function (options) {
  const careTechTemplates = {
    LongSession: svs.caretech.caretech_checks.templates.long_session
  };
  if (isCareTechMessage(options.id)) {
    logger.info("Received caretech-check message: ".concat(JSON.stringify(options)));
    const el = careTechTemplates[options.id];
    if (el) {
      let dialog;
      switch (options.id) {
        case careTechMessageIdEnum.LONGSESSION:
          dialog = new svs.caretech.caretech_checks.LongSession();
          dialog.showInitalTimeLimitDialog(el, options);
          break;
        default:
          break;
      }
    } else {
      logger.warn("Did not find any template for message type: ".concat(options.id));
    }
  } else {
    logger.warn("Did not find any caretech message for message type: ".concat(options.id));
  }
};

 })(window);